import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';

export interface SolicitacaoFeriasPayload {
  DataInicio: string; // ISO date string (yyyy-mm-dd)
  DataFim: string;    // ISO date string (yyyy-mm-dd)
  Observacao?: string;
}

export interface SolicitacaoFeriasResponse {
  mensagem?: string;
  mensagens?: string[];
  sucesso?: boolean;
  codigo?: number;
  raw?: any;
}

export interface SolicitacaoRedefinicaoSenhaResponse {
  mensagem?: string;
  mensagens?: string[];
  sucesso?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SolicitacaoFeriasService {
  private feriasUrl = 'https://localhost:7103/api/SolicitarFerias/solicitar';

  constructor(private http: HttpClient) { }

  /**
   * Envia a solicitação de férias para o backend.
   * Expects ISO date strings in the payload.
   */
  enviarSolicitacaoFerias(payload: SolicitacaoFeriasPayload): Observable<SolicitacaoFeriasResponse> {
    return this.http.post<SolicitacaoFeriasResponse>(this.feriasUrl, payload)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleHttpError(error))
      );
  }

  private handleHttpError(error: HttpErrorResponse) {
    console.error('Erro na requisição HTTP:', error);
    console.error('Status:', error.status);
    console.error('Status Text:', error.statusText);
    console.error('Error Body:', error.error);

    // If server returns status 200 but Angular treats it as an error, try to normalize
    if (error.status === 200 && error.error) {
      const normalized = typeof error.error === 'string'
        ? { mensagem: error.error }
        : error.error;
      return throwError(() => ({ ...error, error: normalized }));
    }

    return throwError(() => error);
  }
}